// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pbscg{font-family:sans-serif;font-size:1.2rem}.cVkE1{animation:gFNa9 1.5s infinite;opacity:0}.HHLde{animation-delay:0s}.pB1tM{animation-delay:.2s}.gNzgR{animation-delay:.4s}@keyframes gFNa9{0%{opacity:0}30%{opacity:1}100%{opacity:0}}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading-dots": `pbscg`,
	"dot": `cVkE1`,
	"blink": `gFNa9`,
	"dot1": `HHLde`,
	"dot2": `pB1tM`,
	"dot3": `gNzgR`
};
export default ___CSS_LOADER_EXPORT___;
